export const permissionIds = {
  USERS_LIST: 'f3a1c2d4-7b21-4e11-9a01-1c2d3e4f5001',
  USERS_CREATE: 'a8d9e0f1-3c42-4b22-8b12-2d3e4f5a6002',
  USERS_UPDATE: 'b1e2f3a4-5d63-4c33-9c23-3e4f5a6b7003',
  USERS_DELETE: 'c2f3a4b5-6e84-4d44-ad34-4f5a6b7c8004',
  PROFILES_LIST: 'd3a4b5c6-7f05-4e55-8e45-5a6b7c8d9005',
  PROFILES_CREATE: 'e4b5c6d7-8016-4f66-9f56-6b7c8d9ea006',
  PROFILES_UPDATE: 'f5c6d7e8-9127-4077-a067-7c8d9eafb107',
  PROFILES_DELETE: '16d7e8f9-a238-4188-8168-8d9eafc0c208',
  CUSTOMERS_LIST: '27e8f9a0-b349-4299-9269-9eafc0d1d309',
  CUSTOMERS_CREATE: '38f9a0b1-c45a-43aa-a37a-afc0d1e2e40a',
  CUSTOMERS_UPDATE: '49a0b1c2-d56b-44bb-847b-b0d1e2f3f50b',
  CUSTOMERS_DELETE: '5ab1c2d3-e67c-45cc-957c-c1e2f304061c',
  SUPPLIERS_LIST: '6bc2d3e4-f78d-46dd-a67d-d2f30415272d',
  SUPPLIERS_CREATE: '7cd3e4f5-089e-47ee-877e-e3041526383e',
  SUPPLIERS_UPDATE: '8de4f506-19af-48ff-987f-f4152637494f',
  SUPPLIERS_DELETE: '9ef50617-2ab0-4901-a980-052637485a50',
  PURCHASE_ORDERS_VIEW: 'af061728-3bc1-4a12-8a81-163748596b61',
  PURCHASE_ORDERS_CREATE: 'b0172839-4cd2-4b23-9b82-2748596a7c72',
  PURCHASE_ORDERS_UPDATE: 'c128394a-5de3-4c34-ac83-38596a7b8d83',
  PURCHASE_ORDERS_DELETE: 'd2394a5b-6ef4-4d45-8d84-496a7b8c9e94',
  SERVICE_WORKS_VIEW: 'e34a5b6c-7f05-4e56-9e85-5a7b8c9daf05',
  SERVICE_WORKS_CREATE: 'f45b6c7d-8016-4f67-af86-6b8c9daeb016',
  SERVICE_WORKS_UPDATE: '056c7d8e-9127-4078-8087-7c9daebfc127',
  SERVICE_WORKS_DELETE: '167d8e9f-a238-4189-9188-8daebfc0d238',
  EMPLOYEES_VIEW: '278e9fa0-b349-429a-a289-9ebfc0d1e349',
  EMPLOYEE_DOCUMENTS_VIEW: '9d1e0f2a-3b4c-4d5e-9f60-1a2b3c4d5e6f',
  EMPLOYEE_SALARY_VIEW: 'af31dbf7-b7a7-4429-93ce-15b09c350a5b',
  EMPLOYEES_CREATE: '389fa0b1-c45a-43ab-838a-afc0d1e2f45a',
  EMPLOYEES_UPDATE: '49a0b1c3-d56b-44bc-948b-b0d1e2f3056b',
  EMPLOYEES_DELETE: '5ab1c2d4-e67c-45cd-a58c-c1e2f304167c',
  PAYROLL_MANAGE: '8c7ba055-de7b-4f95-a375-785ee98a3e1c',
  CLOCKIN_VIEW: '6dee4358-4965-42d7-a062-adce4c1e8cb1',
  CLOCKIN_EDIT: '7eef5469-5a76-43e8-b173-beef5d2f9dc2',
  ASSETS_VIEW: '6bc2d3e5-f78d-46de-868d-d2f30415278d',
  ASSETS_CREATE: '7cd3e4f6-089e-47ef-978e-e3041526389e',
  ASSETS_UPDATE: '8de4f507-19af-48f0-a88f-f415263749af',
  ASSETS_DELETE: '9ef50618-2ab0-4902-8990-052637485ab0',
  EXPENSE_PRODUCTS_VIEW: 'af061729-3bc1-4a13-9a91-163748596bc1',
  EXPENSE_PRODUCTS_CREATE: 'b017283a-4cd2-4b24-ab92-2748596a7cd2',
  EXPENSE_PRODUCTS_UPDATE: 'c128394b-5de3-4c35-8c93-38596a7b8de3',
  EXPENSE_PRODUCTS_DELETE: 'd2394a5c-6ef4-4d46-9d94-496a7b8c9ef4',
  VEHICLE_EXPENSES_VIEW: '4af0d2b1-1f63-4c72-8f44-02b6f3e7a101',
  VEHICLE_EXPENSES_CREATE: '5bf1e3c2-2074-4d83-9f55-13c7f4e8b202',
  VEHICLE_EXPENSES_UPDATE: '6cf2f4d3-3185-4e94-a066-24d805f9c303',
  VEHICLE_EXPENSES_DELETE: '7df305e4-4296-4fa5-b177-35e9160ad404',
  VEHICLES_VIEW: '4b5c6d7e-8f90-4a1b-9c2d-3e4f5a6b7c8d',
  VEHICLES_WRITE: '5c6d7e8f-901a-4b2c-8d3e-4f5a6b7c8d9e',
  DASHBOARD_FINANCIAL_VIEW: 'e34a5b6d-7f05-4e57-ae95-5a7b8c9db005',
  DASHBOARD_HUMAN_RESOURCES_VIEW: 'f45b6c7e-8016-4f68-8f96-6b8c9daeb116',
  DASHBOARD_COMMERCIAL_VIEW: '056c7d8f-9127-4079-9097-7c9daebfc227',
  DASHBOARD_SERVICE_WORKS_VIEW: '167d8ea0-a238-418a-a198-8daebfc0d338',
  DASHBOARD_TST_VIEW: '278e9fb1-b349-429b-8299-9ebfc0d1e449',
  HOLIDAYS_MANAGE: '39faf0c2-c45a-43ac-93ab-bfd1e2f4067c',
  SERVICE_WORKS_VALUES_VIEW: '4afbf1d3-d56b-44ad-a4bc-c2f30417389d',
  PROPOSAL_PRELIMINARY_SERVICES_VALUES_VIEW:
    'd94a4ca8-2e0a-4ac5-b076-5fb547596911',
  PROPOSAL_MACHINES_AND_EQUIPMENTS_VALUES_VIEW:
    'e5a5a6db-7efc-470e-a996-c1495e7d64d2',
  PROPOSAL_PROJECT_DOCUMENTATION_VALUES_VIEW:
    'ab0616b7-63ca-4a65-b622-60d80d87e033',
  PROPOSAL_SPECIALIZED_LABOR_VALUES_VIEW:
    '0dcd5b55-e813-4f41-9806-1bdb067e9ba4',
  PROPOSAL_ITEMS_VALUES_VIEW: '3f662b0f-c381-49fa-9152-d51bfeee5115',
  PROPOSAL_CONTRACTUAL_VALUES_VIEW: 'fd445a88-2a22-4e45-bcf4-64c96ba8cc26',
  SERVICE_WORKS_FULL_ACCESS: '5bc0a2e4-e67c-45ce-b69d-c2e2f304278d',
  ASSET_LINKS_VIEW: '6cd1b3f5-f78d-46de-868d-d2f3041527ae',
  ASSET_LINKS_CREATE: '7de2c406-089e-47ef-978e-e3041526389f',
  SERVICE_WORKS_COMPLETE: '8ef3d517-19af-48f0-a89f-f415263749b0',
  PURCHASE_INVOICES_VIEW: 'a0b1c2d3-5ef6-4a14-aa02-2748596a7c83',
  ASSET_CHECK_CREATE: 'd157b43b-8c38-46bc-b2a1-007b0cdae7a5',
  SERVICE_WORK_EXPENSES_VIEW: '6c595677-8c2b-49fe-bd54-f5381ce7b807',
  TOOLS_VIEW: '17bde6f8-e3f8-4dcb-8d61-54466442c524',
  TOOLS_CREATE: 'a97afe1c-055c-432e-82a1-2390edb81c7a',
  TOOL_LINKS_VIEW: '3a8c462d-1a67-47e5-9e90-e464117a2b60',
  TOOL_LINKS_CREATE: 'b8942ab7-69f9-4825-b32b-0abdfbaacf59',
  TRAININGS_VIEW: '2f5c8a91-6d34-4b27-9c18-73ae40f5d612',
  ST_VIEW: '7c8d9e0f-1a2b-3c4d-5e6f-7a8b9c0d1e2f',
  SERVICE_WORK_MEASUREMENTS_VIEW: '5bd33a1a-09f6-45ff-b93e-1190c19852d9',
  SERVICE_WORK_MEASUREMENTS_WRITE: '62255b5d-bfd0-4982-887b-488ce2ea5913',
} as const;

export type PermissionId = (typeof permissionIds)[keyof typeof permissionIds];
